import { render } from "./S71802.vue?vue&type=template&id=0c1b4d85"
const script = {}
script.render = render

export default script